import useCompanyId from '@/hooks/useCompanyId';
import usePusher from '@/hooks/usePusher';
import useUser from '@/hooks/useUser';
import { action } from '@/lib/api';
import xMindcloudInstance from '@/schema/xMindcloudInstance';
import { globalPubSubChannel } from '@shared/schema/globalPubSubChannel.js';
import { useEffect } from 'react';

const PubSubHandler = () => {
  const user = useUser();
  const client = usePusher();
  const { companyChannel } = useCompanyId();
  const userChannel = user?.jwt?.userChannel;
  const adminChannel = user?.jwt?.adminChannel;
  const globalChannel = globalPubSubChannel;

  const handleMessage = (channel) => {
    return (data) => {
      // If a senderId is passed, we don't want to handle our own messages.
      const senderId = data?.meta?.senderId;
      const instanceId = data?.meta?.instanceId || data?.['x-mindcloud-instance'];
      const userId = user?.jwt?.id;

      if (senderId && senderId === userId && channel !== userChannel) {
        return;
      }

      const messageType = data?.type;

      if (instanceId === xMindcloudInstance) {
        return;
      }

      // Call a custom reducer.
      action(`GET_PUB_SUB_MESSAGE_${messageType || 'general'}`, data);
    };
  };

  useEffect(() => {
    if (typeof client?.subscribe !== 'undefined' && companyChannel) {
      client.subscribe(companyChannel, handleMessage(companyChannel));
      return () => client.unsubscribe(companyChannel);
    }
  }, [companyChannel, client]);

  useEffect(() => {
    if (typeof client?.subscribe !== 'undefined' && userChannel) {
      client.subscribe(userChannel, handleMessage(userChannel));
      return () => client.unsubscribe(userChannel);
    }
  }, [userChannel, client]);

  useEffect(() => {
    if (typeof client?.subscribe !== 'undefined' && globalChannel) {
      client.subscribe(globalChannel, handleMessage(globalChannel));
      return () => client.unsubscribe(globalChannel);
    }
  }, [globalChannel, client]);

  useEffect(() => {
    if (typeof client?.subscribe !== 'undefined' && adminChannel) {
      client.subscribe(adminChannel, handleMessage(adminChannel));
      return () => client.unsubscribe(adminChannel);
    }
  }, [adminChannel, client]);

  return null;
};

export default PubSubHandler;
